(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxCustomLocalizationInput', {
		controller: MxCustomLocalizationInputCtrl,
		controllerAs: 'vm',
		bindings: {
			value: '=',
			customEditor: '<',
			activated: '@?',
			readOnly: '<?',
		},
	});

	MxCustomLocalizationInputCtrl.$inject = ['$scope', '$element', '$compile'];

	function MxCustomLocalizationInputCtrl($scope, $element, $compile) {
		var vm = this;

		vm.$onInit = function () {
			var _elem = angular.element(
				'<' +
					vm.customEditor.editorType +
					' ' +
					vm.customEditor.modelAttrKey +
					'="vm.value" ' +
					Object.keys(vm.customEditor.params)
						.map(function (k) {
							return k + '="vm.customEditor.params[\'' + k + '\']" ';
						})
						.join('') +
					'data-read-only="vm.readOnly" ' +
					'activated="{{vm.activated}}" ' +
					'localizable="false">' +
					'</' +
					vm.customEditor.editorType +
					'>'
			);
			$element.append(_elem);
			$compile(_elem)($scope);
		};
	}
})();
